export default __webpack_public_path__ + "static/media/COM-AVAX.dcebcfb5.png";